import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import HeroSection from "@/pages/home/components/HeroSection";
import RankSection from "@/pages/home/components/RankSection";
import ChannelsSection from "@/pages/home/components/ChannelsSection";
import PicksSection from "@/pages/home/components/PicksSection";
import VoiceSection from "@/pages/home/components/VoiceSection";
import FaqSection from "@/pages/home/components/FaqSection";
import { faqs } from "@/mocks/faqs";
import { site } from "@/mocks/site";

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("all");
  const [query, setQuery] = useState("");

  const handleSelectChannel = (id: string) => {
    setActiveCategory(id);
    setQuery("");
    window.setTimeout(() => {
      document.getElementById("rank")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  };

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: site.name,
      url: "https://51.cg/",
      description: site.intro,
      potentialAction: {
        "@type": "SearchAction",
        target: "https://51.cg/?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: site.name,
      url: "https://51.cg/",
      email: site.email,
      description: "以热度排行为核心的中文内容聚合门户，汇总实时热门吃瓜榜与焦点事件排行。",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Seo
        title="51吃瓜榜 - 今日热点事件排行与最新焦点汇总"
        description="打开51吃瓜榜，一眼看清今日焦点事件排行。汇总实时最新焦点与围观热度排名，吃瓜网友持续更新，热门事件一榜掌握，快速找到大家正在讨论的焦点话题。"
        keywords="51.cg,51吃瓜榜,热门吃瓜榜,今日瓜榜,最新焦点,热门事件排行"
        path="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <RankSection
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
          query={query}
          onQueryChange={setQuery}
        />
        <ChannelsSection activeCategory={activeCategory} onSelect={handleSelectChannel} />
        <PicksSection />
        <VoiceSection />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}